import React, { useRef } from "react";
import { useField, Field } from "formik";
import AppTelephone, { AppTelephoneProps } from "src/commun/composants/formulaire/AppTelephone/AppTelephone";
import useScrollToError from "src/commun/composants/formulaire/formik/hooks/useScrollToError";

export type AppTelephoneFormikProps = Omit<AppTelephoneProps, "onChange" | "value" | "error"> & {
  formulaireSoumis?: boolean;
};

const AppTelephoneFormik = ({ name, formulaireSoumis = false, ...reste }: AppTelephoneFormikProps) => {
  const [, { error, touched }] = useField(name);
  const ref = useRef(undefined);
  useScrollToError(name, ref);

  return (
      <Field
        fieldRef={ref}
        name={name}
        error={error}
        touched={formulaireSoumis || touched}
        as={AppTelephone}
        {...reste}
      />
  );
};

export default AppTelephoneFormik;
